<template>
    <div>
        <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>会员卡管理</el-breadcrumb-item>
            <el-breadcrumb-item>会员卡列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-input placeholder="请输入会员卡名称" clearable v-model="queryInfo.query" @clear="getList()">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="7">
                    <el-button type="primary" @click=" addDialogVisible = true">上架 / 下架会员卡</el-button>
                    <el-button type="primary" @click=" add1DialogVisible = true">添加会员卡</el-button>
                </el-col>
                <el-col :span="11">
                    <div style="padding: 20px 10px;text-align: right;color: #ccc;font-size: 12px;">
                        <span>注：直接点击‘添加会员卡’可新增卡片且不影响现有排序，上架/下架会员卡操作可能导致顺序变动。</span>
                    </div>
                </el-col>
            </el-row>
            
            <!--搜索与添加区域-->
            <!--用户列表区域-->
            <el-table :data="list"  :key="list.index" style="width: 100%" stripe size="small" height="600">
                <el-table-column label="ID" type="index"  width="40"></el-table-column>
                <el-table-column label="会员卡名称" prop="cardname" width="200"></el-table-column>
                <el-table-column label="会员卡类型" prop="cardclass" width="200"></el-table-column>
                <el-table-column label="价格" prop="price" width="200"></el-table-column>
                <el-table-column label="描述" prop="carddescribe" width="200"></el-table-column>
                <el-table-column label="备注" prop="remark" width="200"></el-table-column>
                <el-table-column label="排序" width="100">
                    <template slot-scope="scope">
                        <el-input
                            v-if="scope.row.editSort"
                            v-model="scope.row.sortid"
                            size="mini"
                            @blur="handleSortBlur(scope.row)"
                            @keyup.enter.native="handleSortBlur(scope.row)"
                            style="width: 60px"
                        ></el-input>
                        <span v-else @click="handleSortClick(scope.row)" style="cursor: pointer;">
                            {{ scope.row.sortid }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope"> 
                        <!-- <el-button type="warning" icon="el-icon-arrow-up" size="mini" @click="SortInfo(scope.row.id,'up')" circle></el-button>
                        <el-button type="warning" icon="el-icon-arrow-down" size="mini" @click="SortInfo(scope.row.id,'down')" circle></el-button> -->
                        <el-tooltip class="item" effect="dark" content="下架" placement="top">
                            <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelInfo(scope.row.id)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <!--用户列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[1, 5, 10, 20]"  :page-size="queryInfo.pagesize" 
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
            <!--添加用户对话框-->
            <el-dialog title="上架/下架会员卡" :visible.sync="addDialogVisible" width="50%">
                
                <div style="display: flex; justify-content: center;">
                    <el-transfer v-model="mycards" :data="cards" :titles="['会员卡种类', '我的会员卡']"></el-transfer>
                </div>
                
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="AddInfo">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog title="添加会员卡" :visible.sync="add1DialogVisible" width="50%">
                <el-select v-model="addcard" filterable placeholder="请选择会员卡" style="width:300px">
                    <el-option v-for="item in newcards" :key="item.id" :label="`${item.cardname} - ¥${item.price}`" :value="item.id"></el-option>
                </el-select>                                
                <span slot="footer" class="dialog-footer">
                    <el-button @click="add1DialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="AddInfo1">确 定</el-button>
                </span>
            </el-dialog>
            <!--添加用户对话框-->
        </el-card>
    </div>
</template>
<script>
    export default {
        data() {
            return{
                queryInfo: {
                    storeid:window.sessionStorage.getItem('joinstoreid_token'),
                    query: '',
                    pagenum: 1,
                    pagesize: 10
                },
                total:0,
                list: [],
                addDialogVisible:false,
                editDialogVisible:false,
                add1DialogVisible:false,
                storeid:window.sessionStorage.getItem('joinstoreid_token'),

                classlist:[],
                cards: [],
                mycards: [],
                newcards:[],
                addcard:''
            }
        },
        created() {
            this.getClass()
            this.getList()
            this.generateData()
        },
        // 在 mounted 中添加全局点击事件监听
        mounted() {
            document.addEventListener('click', this.handleDocumentClick);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.handleDocumentClick);
        },
        methods:{
            handleSortClick(row) {
                // 添加 editSort 属性到行数据
                this.$set(row, 'editSort', true);
                // 下一个 tick 聚焦输入框
                this.$nextTick(() => {
                    // 这里需要获取到 input 元素并聚焦
                    // 可能需要给 el-input 添加 ref 属性
                });
            },
            handleSortBlur(row) {
                row.editSort = false;
                // 这里可以添加保存排序值的逻辑
                // 例如调用 API 更新 sortid
                this.updateSortId(row.id, row.sortid);
            },
            async updateSortId(id,sortid){
                const { data: res } = await this.$http.get('updatesort/',{params:{id:id,sortid:sortid}})
                if(res.status===0)
                {
                    this.getList()
                }
            },
            async generateData() { 
                const { data: res } = await this.$http.get('cards/',{params:{storeid:this.storeid}})
                
                this.cards = res.data
                this.mycards = res.mydata
                this.newcards = this.cards.filter(item => !this.mycards.includes(item.id));
            },
            async getClass(){
                const { data: res } = await this.$http.get('cardclass/')
                this.classlist = res.data
                // console.log(this.classlist);
            },
            async getList() {
                const { data: res} = await this.$http.get('storecardlist/',{ params: this.queryInfo })
                if(res.status == 1){
                    this.total = res.data.totalCount;
                    this.list = res.data.list.map(v => {
                      //在返回的数据里增加一条数据
                      // console.log(v.fields)
                      return v.fields
                    })
                }
                    for (let index = 0; index < res.data.list.length; index++) {
                        this.list[index].id= res.data.list[index].pk;
                    }
                    // console.log(this.userlist)
            },
            handleSizeChange(newSize){
            // console.log(newSize)
            this.queryInfo.pagesize = newSize
            this.getList()
        },
        handleCurrentChange(newPage){
            // console.log(newPage)
            this.queryInfo.pagenum = newPage
            this.getList()
        },
        async AddInfo(){

                const { data:res } = await this.$http.post('storecardadd/',{storeid:this.storeid,mycards:this.mycards})
                if(res.status===0)
                {
                    this.$message.success('上架成功！')
                    this.addDialogVisible = false
                    this.mycards = []
                    this.getList()
                    this.generateData()
                }
        },
        async AddInfo1(){
            const { data:res } = await this.$http.post('storecardadd1/',{storeid:this.storeid,addcard:this.addcard})
            if(res.status===0)
            {
                this.$message.success('添加成功！')
                this.add1DialogVisible = false
                this.getList()
                this.generateData()
            }
        },
        async SortInfo(id,sign){
            const { data: res } = await this.$http.get('storecardsort/'+ id,{ params: {sign:sign} })
            if(res.status == 0){
                this.$message.success('设置成功！')
                this.getList()
            }
            
        },
        async DelInfo(id){
            const confirmResult = await this.$confirm('是否要删除此信息吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).catch(err => err)

                if (confirmResult !== 'confirm'){
                    return this.$message.info('已取消删除！')
                }
                const { data: res } = await this.$http.get('storecarddel/'+ id)
            
                if (res.status === 0) { 
                    this.$message({message: '删除成功！',type: 'success'})
                }
                this.getList()
        },
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
    height: 0px;
    
    }
    /deep/ .el-transfer-panel{
        width: 400px; /* 左右两个穿梭框的高度和宽度 */
    }



</style>